import * as types from "@/store/constants/types";
import store from "@/store/index";
export default {
  [types.GET_FEEDS](state: any, payLoad: any) {
    state.feeds = Object.freeze([...state.feeds, ...payLoad]);
  },
  [types.ACT_FEED](state: any, payLoad: any) {
    const newFeeds = [...state.feeds];
    newFeeds.shift();
    state.feeds = Object.freeze(newFeeds);
  },
  [types.SKIP_FEED](state: any, payLoad: any) {
    const newFeeds = [...state.feeds];
    newFeeds.shift();
    state.feeds = Object.freeze(newFeeds);
  },
  [types.REPLACE_VIP_OFFER_FEED](state: any, payLoad: any) {
    //替换feed中有的vip的feed:
    const newFeeds = [...state.feeds];
    for (const i in newFeeds) {
      if (newFeeds[i].offer && newFeeds[i].offer.kind === "feed_vip") {
        newFeeds[i] = store.getters[types.GETTER_RANDOM_FEED_OFFER]();
      }
    }
    state.feeds = newFeeds;
  },
  [types.REPLACE_SUPER_PAY_OFFER_FEED](state: any, payLoad: any) {
    //替换feed中有的vip的feed:
    const newFeeds = [...state.feeds];
    for (const i in newFeeds) {
      if (newFeeds[i].offer && newFeeds[i].offer.kind === "feed_super_pay") {
        newFeeds[i] = store.getters[types.GETTER_RANDOM_FEED_OFFER]();
      }
    }
    state.feeds = newFeeds;
  },
  [types.REPLACE_BACK_UP_OFFER_FEED](state: any, payLoad: any) {
    //替换feed中有的vip的feed:
    const newFeeds = [...state.feeds];
    for (const i in newFeeds) {
      if (newFeeds[i].offer && newFeeds[i].offer.kind === "feed_back_up") {
        newFeeds[i] = store.getters[types.GETTER_RANDOM_FEED_OFFER]();
      }
    }
    state.feeds = newFeeds;
  }
};
